<div class="layout-h">
  <div class="wrapper">
    <!-- top navbar-->
    <app-headerh class="topnavbar-wrapper"></app-headerh>
    <!-- offsidebar-->
    <app-offsidebar class="offsidebar"></app-offsidebar>
    <!-- Main section-->
    <section class="section-container">
      <!-- Page content-->
      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
    </section>
    <!-- Page footer-->
    <footer class="footer-container" app-footer></footer>
  </div>
</div>
